import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
// Cascade-layer order statement — MUST be imported first (before App's eager CSS
// graph) so it precedes every layered rule in the emitted bundle (ADR 030 §5 step 0).
import './layers.css'
import App from './app/App'
import './index.css'
import './common/styles/nordic.css'
import './common/styles/atelier.css'
import './common/styles/swiss.css'
import { installChunkErrorHandler } from './lib/lazy-with-retry'

installChunkErrorHandler()

// NOTE: a fresh page load used to strip `/mod/<id>` from the URL here ("start
// in chat-only view"). That predated ADR 028 (module-pane single source of
// truth), which makes the URL the canonical seed for the open module: a deep
// link / hard refresh must render that module's pane on the first paint. The
// strip silently defeated that — MainLayout saw an empty module slot and
// redirected to the *remembered* module, so e.g. a hard refresh on Places
// bounced to whatever module was last viewed. Removed so the URL is honored.

// Configure StatusBar for white header on iOS/Android native app
if (Capacitor.isNativePlatform()) {
  import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
    StatusBar.setStyle({ style: Style.Light });
    StatusBar.setOverlaysWebView({ overlay: true });
  }).catch(() => {});

  // Force WKWebView to evaluate env(safe-area-inset-*) on first paint.
  // Without this, safe area values are 0 until the first user interaction.
  requestAnimationFrame(() => {
    document.body.style.paddingTop = 'env(safe-area-inset-top)';
    requestAnimationFrame(() => {
      document.body.style.paddingTop = '';
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
